<template>
  <div class="aiChatPage aiPageBg">
    <navbar :nav="nav"></navbar>
    <div
      class="chatContent"
      :class="{ istags: istags, istabbar: showTabbar }"
      id="data-list-content"
    >
      <div class="chatTitle">
        <div>AIアシスト</div>
        <van-switch
          @change="changeSwitch"
          v-model="checked"
          active-color="#2B99FF"
          inactive-color="#AFC8DF"
          :disabled="disabled"
        >
        </van-switch>
      </div>
      <div class="chatMain">
        <!-- <div class="chatList chatleft">
          <img class="avatar" src="../../assets/img/avatar2.png" />
          <div class="chatBox">
            <div class="triangle"></div>
            <div class="chatItem">
              <div>
                どんな画像を生成したいですか？画像生成のキーワードを教えてください！
              </div>
              <p>例：猫 サングラス(３つまで、スペースで分けて入力しましょう)</p>
            </div>
          </div>
        </div>
        <div class="chatList chatleft">
          <img class="avatar" src="../../assets/img/avatar2.png" />
          <div class="chatBox">
            <div class="triangle"></div>
            <div class="chatItem">
              <div>
                どんな画像を生成したいですか？画像生成のキーワードを教えてください！
              </div>
              <p>例：猫 サングラス(３つまで、スペースで分けて入力しましょう)</p>
            </div>
          </div>
        </div>
        <div class="chatList chatright">
          <div class="chatBox">
            <div class="chatItem">
              <div class="triangle"></div>
              <div>猫 サングラス</div>
            </div>
          </div>
          <img class="avatar" src="../../assets/img/avatar.png" />
        </div>
        <div class="chatList chatleft">
          <img class="avatar" src="../../assets/img/avatar2.png" />
          <div class="chatBox">
            <div class="chatItem">
              <div class="triangle"></div>
              どんな画像を生成したいですか？画像生成のキーワードを教えてください！
            </div>
            <div class="chatItem blueItem">
              どんな画像を生成したいですか？画像生成のキーワードを教えてください！
            </div>
            <div class="chatItem blueItem">
              3、ヒップなスタイルの猫がサングラスをかけてオープンカフェでくつろいでいる。
            </div>
          </div>
        </div>
        <div class="chatList chatright">
          <div class="chatBox">
            <div class="chatItem">
              <div class="triangle"></div>
              <div>
                1、クールなサングラスをかけたおしゃれな猫がのんびりと日光浴をしている。
              </div>
            </div>
          </div>
          <img class="avatar" src="../../assets/img/avatar.png" />
        </div>
        <div class="chatList chatleft">
          <img class="avatar" src="../../assets/img/avatar2.png" />
          <div class="chatBox">
            <div class="chatItem blueItem" @click="shengcheng()">
              1、生成
            </div>
            <div class="chatItem blueItem">
              2、再编辑
            </div>
            <div class="chatItem blueItem" @click="sendNum=0;messageType ='M2';Websocket()">
              3、更详细指定
            </div>
          </div>
        </div> -->
        <div v-if="!taocancishu">
          <div class="chatList chatleft">
            <img class="avatar" src="../../assets/img/avatar2.png" />
            <div class="chatBox">
              <div class="triangle"></div>
              <div class="chatItem">
                <div @click="$router.push({ path: `/unlockPackage` })">
                  本日の生成枚数は上限に達しました。生成枚数を増やすためにプランを<span
                    style="color: #2b99ff; cursor: pointer;"
                    >変更</span
                  >するか、明日再試行してください。
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!checked && taocancishu">
          <div
            class="chatList"
            v-for="(item, index) in chatObgOFF"
            :key="index"
            :class="item.type == 'chat' ? 'chatleft' : 'chatright'"
          >
            <img
              class="avatar"
              src="../../assets/img/avatar2.png"
              v-if="item.type == 'chat'"
            />
            <div class="chatBox">
              <div class="triangle" v-if="!item.chat"></div>
              <div class="chatItem" v-if="!item.chat">
                <div>
                  {{ item.msg }}
                </div>
                <p v-if="item.desc">{{ item.desc }}</p>
              </div>
              <div
                class="chatItem blueItem"
                v-if="item.generate"
                @click="shengcheng(index)"
              >
                1、決定してスタイルを選択する
              </div>
              <div
                class="chatItem blueItem"
                v-if="item.generate"
                @click="resetText(index)"
              >
                2、文言を再編集
              </div>
            </div>
            <img
              class="avatar"
              src="../../assets/img/avatar.png"
              v-if="item.type == 'user'"
            />
          </div>
        </div>
        <div v-if="checked && taocancishu">
          <div
            class="chatList"
            v-for="(item, index) in chatObg"
            :key="index"
            :class="item.type == 'chat' ? 'chatleft' : 'chatright'"
          >
            <img
              class="avatar"
              src="../../assets/img/avatar2.png"
              v-if="item.type == 'chat'"
            />
            <div class="chatBox">
              <div class="triangle" v-if="!item.chat"></div>
              <div class="chatItem" v-if="!item.chat">
                <div>
                  {{ item.msg }}
                </div>
                <p v-if="item.desc">{{ item.desc }}</p>
              </div>
              <div v-if="item.chat">
                <div class="chatItem" v-if="item.chatFirst">
                  精度が高い画像を生成するために、以下の文言をご提案しました。マッチした文言を選択してください
                </div>
                <div
                  class="loadingText"
                  v-if="item.type == 'chat' && item.loading && index < 3"
                >
                  <div>頑張って考えているよ～♪</div>
                  <van-loading type="spinner" color="#2b99ff" />
                </div>
                <div
                  class="chatItem blueItem"
                  v-for="(k, j) in item.msg"
                  :key="j"
                  @click="checkMsg(k, index)"
                >
                  {{ k }}
                </div>
              </div>
              <div class="loadingText" v-if="isLoadGuanjianci">
                <van-loading type="spinner" color="#2b99ff" />
              </div>
              <!-- //询问是否生成 -->
              <div
                class="chatItem blueItem"
                v-if="item.generate"
                @click="shengcheng(index)"
              >
                1、決定してスタイルを選択する
              </div>
              <div
                class="chatItem blueItem"
                v-if="item.generate"
                @click="resetText(index)"
              >
                2、文言を再編集
              </div>
              <div
                class="chatItem blueItem"
                v-if="
                  item.generate &&
                    checked &&
                    checkTagNum < 2 &&
                    tagsArr.length > 0 &&
                    !handleGuanjianci
                "
                @click="
                  messageType = 'M2';
                  guanjianci(index);
                "
              >
                3、更に詳細指定する
              </div>
              <!-- 选择关键词后显示的 -->

              <div v-if="item.content">
                <div
                  class="chatItem blueItem"
                  v-for="(k, j) in item.content"
                  :key="j"
                  @click="checkMsg2(k.content, index, k.id)"
                >
                  {{ k.content }}
                </div>
              </div>
              <!-- //重新编辑后只能选择生成/详细指定 -->
              <div v-if="item.isReset">
                <div class="chatItem blueItem" @click="shengcheng(index)">
                  1、決定してスタイルを選択する
                </div>
                <div
                  class="chatItem blueItem"
                  v-if="checked"
                  @click="resetText(index)"
                >
                  2、文言を再編集
                </div>

                <div
                  v-if="
                    checked &&
                      checkTagNum < 2 &&
                      tagsArr.length > 0 &&
                      !handleGuanjianci
                  "
                  class="chatItem blueItem"
                  @click="
                    messageType = 'M2';
                    guanjianci(index);
                  "
                >
                  3、更に詳細指定する
                </div>
              </div>
            </div>
            <img
              class="avatar"
              src="../../assets/img/avatar.png"
              v-if="item.type == 'user'"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="chatTags" v-if="istags && checkTagNum < 3">
      <div
        class="tags"
        v-for="(item, index) in tagsArr"
        :key="index"
        @click="checkGuanjianci(item)"
      >
        {{ item.keyword }}
      </div>
    </div>
    <div class="chatInputBox">
      <img
        v-if="!showTabbarIcon"
        class="icon"
        :class="showTabbar ? 'transform' : ''"
        @click="
          scrollToBottom();
          chatShowTab();
        "
        src="../../assets/img/icon/icon_arrow_top.png"
      />
      <!-- <input
        class="sendInput"
        v-model="sendText"
        placeholder="文言を入力しましょう"
        
        @keyup.native="sendMsg()"
      /> -->
      <van-field
        class="sendInput"
        v-model="sendText"
        :disabled="disabled"
        placeholder="文言を入力しましょう"
        @keyup.enter.native="enterSendMsg()"
        @input="getSendText()"
        @focus="scrollToBottom()"
      />
      <img
        class="icon"
        @click="sendMsg"
        v-if="!dontSendText && !handleSenBtn && !isLoadGuanjianci"
        src="../../assets/img/icon/icon_send.png"
      />
      <img
        class="icon"
        v-if="(dontSendText && !handleSenBtn) || isLoadGuanjianci"
        src="../../assets/img/icon/icon_send_dis.png"
      />
      <img
        class="icon"
        @click="handleSenMsg"
        v-if="handleSenBtn"
        src="../../assets/img/icon/icon_send.png"
      />
    </div>
    <tabbar v-show="showTabbar"></tabbar>
  </div>
</template>

<script>
import Vue from "vue";
import { Toast } from "vant";

Vue.use(Toast);
import navbar from "../../components/navbar/index.vue";
import tabbar from "../../components/tabbar/index.vue";
import { sendSock, createWebSocket, closeSock } from "../../until/socket";
import { memberPackage } from "@/http/home";

export default {
  components: {
    navbar,
    tabbar
  },
  data() {
    return {
      nav: {
        back: false,
        title: "Smart Sketcher AI",
        chat: true
      },
      checked: true,
      sendText: "",
      istags: false,
      showTabbar: false,
      messageType: "M1",
      keyWordsId: "",
      sendNum: 0,
      chatObg: [
        {
          type: "chat",
          msg:
            "どんな画像を生成したいですか？画像生成のキーワードを教えてください！",
          desc: "例：猫 サングラス(３つまで、スペースで分けて入力しましょう)"
        }
      ],
      chatObgOFF: [
        // {
        //   type: "chat",
        //   msg: "AIアシストをOFFにしました。キーワードを出してはじめましょう",
        //   desc: "送信したら3秒後にそのまま生成画面に進む。"
        // },
        {
          type: "chat",
          msg:
            "AIアシストをOFFにしました。生成したいイメージの文言を入力しましょう！",
          desc:
            "例：ネクタイを付けるかわいい猫が走っている。ハッピー、夕日、ローアングル"
        }
      ],
      userMsg: [],
      tagsArr: [],
      keyword: "",
      dontSendText: false,
      isResetText: false,
      dontCheckOther: false,
      disabled: false,
      handleSenBtn: false,
      checkTagNum: 0,
      showTabbarIcon: false,
      userMsgOFF: [],
      guanbiSendText: "",
      dakaiSendText: "",
      taocancishu: true,
      handleGuanjianci: false,
      isChangeText: false,
      isHandlKey: false,
      guanjianciId: [],
      zaibianji: false,
      isLoadGuanjianci: true
    };
  },
  created() {
    localStorage.removeItem("websocketStatus");
    localStorage.removeItem("firstMessageContent");
    Toast.clear();
    if (window.innerWidth > 1439) {
      this.showTabbarIcon = true;
    }
    memberPackage().then(res => {
      let { data, code } = res.data;
      if (code == 200) {
        if (!data || data.alreadyGenerateNumber >= data.generateNumber) {
          this.taocancishu = false;
          this.dontSendText = true;
          this.checked = false;
          this.disabled = true;
        } else {
          this.taocancishu = true;
          this.disabled = true;
          this.init();
        }
      }
    });
  },
  methods: {
    init() {
      createWebSocket(this.global_callback);
      this.messageType = "M2";
      let query = {
        messageType: "M2"
      };
      sendSock(JSON.stringify(query));
    },
    global_callback(msg) {
      this.sendText = "";
      // console.log("websocket的回调函数收到服务器信息：" + JSON.stringify(msg));
      if (this.messageType == "M1") {
        let content = msg.responseMessageContent;
        var contentArr = content.split("\n");
        if ((this.userMsg.length = 1)) {
          this.chatObg[2].loading = false;
          this.chatObg[2].msg = contentArr;
          this.dontSendText = true;
        } else {
          this.chatObg.push({
            type: "chat",
            chat: true,
            msg: contentArr
          });
        }
      }
      if (this.messageType == "M2") {
        if (this.chatObg.length > 3) {
          this.istags = true;
        }
        this.isLoadGuanjianci = false;
        this.disabled = false;
        this.tagsArr = JSON.parse(msg.responseMessageContent);
      }
      if (this.messageType == "M3") {
        this.istags = false;
        let content = JSON.parse(msg.responseMessageContent);
        let text = [];
        for (let i in content) {
          text.push(content[i]);
        }
        this.chatObg.push({
          type: "chat",
          chat: false,
          generate: false,
          msg: "画像を以下の「" + this.keyword + "」に指定する",
          content: text
        });
      }
      this.scrollToBottom();
    },
    getSendText() {
      //输入的序号 与 第三条数据msg匹配，AI返回数据包含输入序号时 发送按钮可点击
      if (!this.checked) {
        return;
      }
      if (this.chatObg.length == 3) {
        let max = this.chatObg[2].msg.length;
        for (let i = 1; i <= max; i++) {
          if (this.sendText == i) {
            this.handleSenBtn = true;
            break;
          } else {
            this.handleSenBtn = false;
          }
        }
      }
    },
    enterSendMsg() {
      // 回车发送，第一次发送 / 选择序号发送
      if (!this.handleSenBtn) {
        this.sendMsg();
      } else {
        this.handleSenMsg();
      }
    },
    handleSenMsg() {
      // 根据序号手动回复，成功后不可点击回复
      let index = this.sendText - 1;
      let msg = this.chatObg[2].msg[index];
      this.sendText = "";
      this.checkMsg(msg, index);
    },
    sendMsg() {
      if (this.sendText == "" || this.sendText == null) {
        Toast({
          type: "fail",
          icon: "cross",
          message: "送信内容を入力してください"
        });
        return;
      }
      if (this.checked) {
        //开启对话
        this.chatObg.push({
          type: "user",
          // loading: true,
          msg: this.sendText
        });
        this.dontSendText = true;
        if (this.chatObg.length > 2) {
          this.userMsg.push(this.sendText);
        } else {
          this.userMsg = [];
        }

        if (this.isResetText && this.chatObg.length > 2) {
          //文字再次编辑后 点击发送，不可执行ChatGPT，只能直接生成、关键词选择
          // 如果是手动输入关键词，只能输入一次
          if (this.isChangeText || this.isHandlKey) {
            this.handleGuanjianci = true;
          }
          let data = JSON.parse(JSON.stringify(this.userMsg));
          let obg = data.splice(1);
          let text = "";
          if (obg.length == 1) {
            text = obg[0];
          } else if (obg.length == 2) {
            text = obg[0] + "'" + obg[1] + "'";
          } else {
            text = obg[0] + "'" + obg[1] + "''" + obg[2] + "'";
          }
          if (this.userMsg.length == 0) {
            text = this.sendText;
          }
          this.istags = false; //这时是手动输入关键词发送，
          setTimeout(() => {
            this.chatObg.push({
              type: "chat",
              isReset: true,
              msg: "文言を「" + text + "」に決定しますか?"
            });
            this.scrollToBottom();
          }, 500);
          this.sendText = "";
          this.scrollToBottom();
          console.log("关键词id", this.checkTagNum, this.guanjianciId);
          if (!this.zaibianji) {
            if (this.guanjianciId.length == 1) {
              this.guanjianciId = [];
            }
            if (this.guanjianciId.length == 2) {
              this.guanjianciId.splice(1);
            }
          }
          console.log("关键词id222", this.guanjianciId);
          return;
        }

        localStorage.setItem("firstMessageContent", this.sendText);
        let query = {
          messageType: "M1",
          requestMessageContent: this.sendText
        };
        this.sendText = "";
        this.chatObg.push({
          type: "chat",
          chat: true,
          chatFirst: true,
          loading: true,
          msg: []
        });
        this.messageType = "M1";
        sendSock(JSON.stringify(query));
      } else {
        this.chatObgOFF.push({
          type: "user",
          // loading: true,
          msg: this.sendText
        });
        this.dontSendText = true;
        this.userMsgOFF.push(this.sendText);
        if (this.userMsgOFF && this.userMsgOFF.length == 1) {
          localStorage.setItem("firstMessageContent", this.sendText);
        }
        setTimeout(() => {
          this.chatObgOFF.push({
            type: "chat",
            generate: true,
            msg: "文言を「" + this.sendText + "」に決定しますか?"
          });
          this.sendText = "";
          this.scrollToBottom();
        }, 1000);
      }
      this.scrollToBottom();
    },
    checkMsg(msg, index) {
      //选择某一条消息，问用户是否生成xxx，同时给出三个选项
      if (index.length != 2 && this.chatObg.length != 3) {
        return;
      }
      // msg = msg.slice(3);
      msg = msg.split(". ");
      var lastMsg = msg.slice(-1)[0];
      console.log(msg);
      console.log(lastMsg);
      this.userMsg.push(lastMsg);
      this.chatObg.push({
        type: "user",
        msg: lastMsg
      });
      // 文言を「」に決定しますか?
      setTimeout(() => {
        this.chatObg.push({
          type: "chat",
          generate: true,
          msg: "文言を「" + lastMsg + "」に決定しますか?"
        });
        this.scrollToBottom();
      }, 1000);
      this.handleSenBtn = false;

      this.scrollToBottom();
    },
    checkMsg2(msg, index, id) {
      if (this.chatObg.length - index != 1) {
        return;
      }
      //选择关键词返回的数据
      this.userMsg.push(msg);
      this.chatObg.push({
        type: "user",
        msg: msg
      });
      let arr = JSON.parse(JSON.stringify(this.userMsg));
      arr.shift();
      let content = arr.toString();
      let str3;
      if (arr.length == 2) {
        str3 = arr[0] + "'" + arr[1] + "'";
      } else {
        str3 = arr[0] + "'" + arr[1] + "''" + arr[2] + "'";
      }
      this.dontSendText = true;
      this.handleSenBtn = false;
      // 文言を「」に決定しますか?
      // return
      setTimeout(() => {
        this.chatObg.push({
          type: "chat",
          generate: true,
          msg: "文言を「" + str3 + "」に決定しますか?"
        });
        this.scrollToBottom();
      }, 1000);
    },
    guanjianci(index) {
      if (localStorage.getItem("websocketStatus")) {
        Toast({
          type: "fail",
          icon: "cross",
          duration: 5000,
          message:
            "タイムアウトです。ほかの選択肢を選択するか、右上のボタンを押して文言の生成をやり直しましょう"
        });
        return;
      }
      if (this.chatObg.length - index != 1) {
        return;
      }
      this.chatObg.push({
        type: "user",
        msg: "更に詳細指定する"
      });

      //更详细指定时，可以选择关键词也可以手动输入关键词
      // 手动输入关键词时，发送按钮高亮
      this.isResetText = true;
      this.dontSendText = false;

      this.dontSendText = false;
      // if(this.checkTagNum>=2){
      this.isHandlKey = true; //手动输入关键词时 不能再选择更多关键词
      // }
      this.messageType = "M2";
      let query = {
        messageType: "M2"
      };
      this.dontCheckOther = true; //  选择关键词后  不可返回上一步进行生成、编辑、获取关键词
      this.zaibianji = false;
      sendSock(JSON.stringify(query));
    },
    checkGuanjianci(item) {
      console.log("关键词id", item.id);
      this.guanjianciId.push(item.id);
      this.chatObg.push({
        type: "user",
        msg: item.keyword
      });
      this.keyword = item.keyword;
      this.istags = false;
      this.messageType = "M3";
      let query = {
        messageType: "M3",
        keyWordsId: item.id,
        requestMessageContent: item.keyword
      };
      this.checkTagNum++;
      // 选择某一个关键词时时，可以选择关键词也可以手动输入关键词
      // 手动输入关键词时，发送按钮高亮
      this.isResetText = true;
      this.dontSendText = false;
      if (this.checkTagNum >= 2) {
        this.isHandlKey = true; //手动输入关键词时 不能再选择更多关键词
      } else {
        this.isHandlKey = false;
      }
      sendSock(JSON.stringify(query));
    },
    chatShowTab() {
      if (window.innerWidth < 1024) {
        this.showTabbar = !this.showTabbar;
      }
    },
    changeSwitch(n) {
      if (this.chatObg.length == 1 || this.chatObgOFF.length == 1) {
        this.dontSendText = false;
      }
      if (n) {
        if (this.sendText != "") {
          this.guanbiSendText = this.sendText;
          this.sendText = "";
        }
        if (this.dakaiSendText != "") {
          this.sendText = this.dakaiSendText;
        } else {
          this.sendText == "";
        }
      } else {
        this.dakaiSendText = this.sendText;
        if (this.guanbiSendText != "" || this.sendText != "") {
          this.sendText = this.guanbiSendText;
        } else {
          this.sendText == "";
        }
      }
    },
    resetText(index) {
      Toast.clear();
      let length = 0;
      if (this.checked) {
        length = this.chatObg.length;
      } else {
        length = this.chatObgOFF.length;
      }
      if (length - index != 1) {
        return;
      }
      let data;
      if (this.checked) {
        data = this.userMsg;
        this.chatObg.push({
          type: "user",
          msg: "文言を再編集"
        });
      } else {
        data = this.userMsgOFF;
        this.chatObgOFF.push({
          type: "user",
          msg: "文言を再編集"
        });
      }
      this.zaibianji = true;
      this.dontSendText = false;
      if (!this.checked && data.length == 1) {
        this.sendText = data[0];
      } else {
        let obg = data.splice(1);
        if (obg.length == 1) {
          this.sendText = obg[0];
        } else if (obg.length == 2) {
          this.sendText = obg[0] + "'" + obg[1] + "'";
        } else {
          this.sendText = obg[0] + "'" + obg[1] + "''" + obg[2] + "'";
        }
      }
      if (this.checkTagNum >= 2) {
        this.isChangeText = true;
      }
      this.isResetText = true;
      this.scrollToBottom();
    },
    shengcheng(index) {
      Toast.clear();
      let length = 0;
      let data;
      if (this.checked) {
        length = this.chatObg.length;
        data = this.userMsg;
      } else {
        length = this.chatObgOFF.length;
        data = this.userMsgOFF;
      }
      if (length - index != 1) {
        return;
      }
      let text = "";
      let obg = data;
      if (data.length > 1) {
        obg = data.splice(1);
      }
      if (!this.checked && data.length == 1) {
        text = obg[0];
        // } else {
        // let obg = data.splice(1);
        // text = obg.toString();
      } else if (obg.length == 1) {
        text = obg[0];
      } else if (obg.length == 2) {
        text = obg[0] + "'" + obg[1] + "'";
      } else {
        text = obg[0] + "'" + obg[1] + "''" + obg[2] + "'";
      }
      console.log(this.guanjianciId.join(","));
      if (this.guanjianciId.length > 0) {
        localStorage.setItem("keyWordsId", this.guanjianciId.join(","));
      }
      document.documentElement.scrollTop = 0;
      this.$router.push({ path: `/generateStyle`, query: { text: text } });
    },
    scrollToBottom() {
      this.$nextTick(() => {
        var div = document.getElementById("data-list-content");
        div.scrollTop = div.scrollHeight;
      });
    },
    focusInput() {
      this.scrollToBottom();
    }
  },
  beforeDestroy() {
    localStorage.removeItem("websocketStatus");
    Toast.clear();
    closeSock();
  }
};
</script>

<style>
.aiChatPage.aiPageBg {
  /* width: 100%; */
  height: 100%;
}
.aiChatPage {
  position: relative;
  /* padding-bottom: 120px; */
}
.chatContent {
  width: calc(100% - 30px);
  height: calc(100% - 85px);
  /* margin-bottom: 70px; */
  overflow-y: scroll;
  overflow-x: hidden;
  padding: 0 15px;
}
.chatContent.istags {
  height: calc(100% - 125px);
}
.chatContent.istabbar {
  height: calc(100% - 155px);
}
.chatContent .chatTitle {
  display: flex;
  font-family: ThinFont, MediumFont;
  font-size: 16px;
  font-weight: normal;
  line-height: 24px;
  display: flex;
  align-items: center;
  letter-spacing: 0.9px;
  margin-bottom: 16px;

  color: #ffffff;
}
.chatContent .chatTitle .van-switch {
  width: 48px;
  height: 24px;
  border: 0;
  border-radius: 24px;
  margin-left: 8px;
}
.chatContent .chatTitle .van-switch .van-switch__node {
  width: 20px;
  height: 20px;
  top: 2px;
  transform: translateX(2px);
}
.chatContent .chatTitle .van-switch.van-switch--on .van-switch__node {
  transform: translateX(26px);
}
/* 聊天框 */
.chatMain .avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
}
.chatMain .chatleft .avatar {
  margin-right: 14px;
}
.chatMain .chatright .avatar {
  margin-left: 14px;
}
.chatMain .chatList {
  display: flex;
  align-items: flex-start;
}
.chatMain .chatList.chatright {
  justify-content: flex-end;
}
/* .chatMain .chatList.chatright .chatBox {
  margin-right: 14px;
} */
.chatMain .chatBox {
  max-width: 75%;
  position: relative;
}
.chatMain .chatBox .triangle {
  position: absolute;
  top: 8px;
  z-index: 3;
  width: 0;
  height: 0;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
}
.chatMain .chatleft .triangle {
  left: -6px;
  border-right: 7px solid #ffffff;
}
.chatMain .chatright .triangle {
  right: -6px;
  border-left: 7px solid #0ad666;
}
.chatMain .chatItem {
  width: 100%;
  border-radius: 6px;
  opacity: 1;
  background: #ffffff;
  padding: 8px;
  font-family: RegularFont;
  font-size: 14px;
  font-weight: normal;
  line-height: 22px;
  letter-spacing: 0px;
  margin-bottom: 16px;
  color: #000000;
  box-sizing: border-box;
}
.chatMain .chatList.chatleft .blueItem {
  background: #2b99ff;
  color: #ffffff;
  cursor: pointer;
  font-size: 12px;
}
.chatMain .chatList.chatright .chatItem {
  background: #0ad666;
  color: #ffffff;
}
.chatMain .chatItem p {
  padding: 0;
  margin: 0;
  color: rgba(0, 0, 0, 0.9);
  opacity: 0.5;
}
.chatMain .loadingText {
  text-align: center;
  font-family: RegularFont;
  color: #848484;
  font-size: 14px;
}
.chatInputBox {
  width: calc(100% - 54px);
  height: 48px;
  border-radius: 110px;
  padding: 0 16px 0 8px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  position: fixed;
  bottom: 24px;
  left: 15px;
  z-index: 9;
  overflow: hidden;
}
.chatInputBox .icon {
  width: 24px;
  height: 25px;
  display: block;
  cursor: pointer;
}
.chatInputBox .icon.transform {
  transform: rotate(180deg);
}
.aiChatPage .sendInput {
  border: none;
  font-family: RegularFont;
  font-size: 14px;
  font-weight: normal;
  color: rgba(0, 0, 0, 0.9);
  width: 79%;
  padding: 0;
  height: 48px;
  line-height: 48px;
}
.aiChatPage .sendInput.van-cell::after {
  border: none;
}
.sendInput::input-placeholder {
  color: rgb(35, 32, 54, 0.5);
}
.sendInput::-webkit-input-placeholder {
  color: rgb(35, 32, 54, 0.5);
}
.sendInput::-moz-placeholder {
  color: rgb(35, 32, 54, 0.5);
}
.sendInput::-moz-placeholder {
  color: rgb(35, 32, 54, 0.5);
}
.sendInput::-ms-input-placeholder {
  color: rgb(35, 32, 54, 0.5);
}
.chatTags {
  position: fixed;
  bottom: 80px;
  left: 15px;
  z-index: 9;
  width: calc(100% - 54px);
  height: 38px;
  overflow-x: auto;
  white-space: nowrap;
}
.chatTags .tags {
  background: #ffffff;
  border-radius: 45px;
  height: 36px;
  line-height: 36px;
  box-sizing: border-box;
  border: 1px solid rgba(43, 153, 255, 0.5);
  font-size: 14px;
  color: #2b99ff;
  padding: 0 10px;
  margin-right: 8px;
  display: inline-block;
}
.aiChatPage.aiPageBg .tabbar {
  bottom: 80px;
}
.aiChatPage .van-loading {
  line-height: 40px;
  margin-right: 6px;
}
.aiChatPage .van-loading__spinner.van-loading__spinner--spinner {
  width: 20px;
  height: 20px;
}
@media screen and (min-width: 1439px) {
  .aiChatPage .sendInput {
    width: 93%;
  }
  .chatContent.istags {
    height: calc(100% - 125px); /* no*/
  }
  .chatContent {
    width: calc(100% - 30px); /* no*/
    height: calc(100% - 90px); /* no*/
    /* margin-bottom: 70px; */
    padding: 0 15px; /* no*/
  }
  .chatContent .chatTitle {
    font-size: 16px; /* no*/
    line-height: 24px; /* no*/
    letter-spacing: 0.9px; /* no*/
    margin-bottom: 16px; /* no*/
  }

  .chatContent .chatTitle .van-switch {
    width: 48px; /* no*/
    height: 24px; /* no*/
    border-radius: 24px; /* no*/
    margin-left: 8px; /* no*/
  }
  .chatContent .chatTitle .van-switch .van-switch__node {
    width: 20px; /* no*/
    height: 20px; /* no*/
    top: 2px; /* no*/
    transform: translateX(2px); /* no*/
  }
  .chatContent .chatTitle .van-switch.van-switch--on .van-switch__node {
    transform: translateX(26px); /* no*/
  }
  .chatMain .chatBox {
    max-width: 70% !important; /* no*/
  }
  .chatMain .chatBox .triangle {
    top: 10px; /* no*/
    border-right: 8px solid #ffffff; /* no*/
    border-top: 8px solid transparent; /* no*/
    border-bottom: 8px solid transparent; /* no*/
  }
  .chatMain .chatleft .triangle {
    left: -8px; /* no*/
  }
  .chatMain .chatright .triangle {
    right: -8px; /* no*/
    border-right: 0;
    border-left: 8px solid #0ad666; /* no*/
  }
  .chatMain .chatItem {
    font-size: 16px !important; /* no*/
    line-height: 24px; /* no*/
  }
  .chatMain .chatList.chatleft .blueItem {
    font-size: 12px; /* no*/
  }
  .chatInputBox {
    height: 48px; /* no*/
    border-radius: 110px; /* no*/
    padding: 0 16px 0 8px; /* no*/
    bottom: 160px; /* no*/
  }
  .chatInputBox .sendInput {
    font-size: 14px; /* no*/
    height: 48px; /* no*/
    line-height: 48px; /* no*/
  }
  .chatTags {
    bottom: 202px; /* no*/
  }
  .chatInputBox,
  .chatTags {
    width: 420px; /* no*/
    left: 50%; /* no*/
    margin-left: -225px; /* no*/
  }
  .chatTags .tags {
    border-radius: 45px; /* no*/
    height: 36px; /* no*/
    line-height: 36px; /* no*/
    font-size: 14px; /* no*/
    padding: 0 10px; /* no*/
    margin-right: 8px; /* no*/
  }
  .chatInputBox .icon {
    width: 24px; /* no*/
    height: 25px; /* no*/
  }
  .aiChatPage .van-loading {
    line-height: 40px; /* no*/
    margin-right: 6px; /* no*/
  }
  .aiChatPage .van-loading__spinner.van-loading__spinner--spinner {
    width: 20px; /* no*/
    height: 20px; /* no*/
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/chat/index.vue